import React from "react";
import {useNavigate} from "react-router-dom";
import {selectUserInfo} from "../../../features/account/accountSlice";
import {useAppSelector} from "../../../hooks";
import {MY_PATIENTS_ROUTE} from "../../../routes";
import {DATA_LIST_PAGE_SIZE} from "../../../settings";
import {Breadcrumbs} from "../../Widgets/Breadcrumbs/Breadcrumbs";
import {PatientsList} from "../../Widgets/PatientsList/PatientsList";
import {MenuItem} from "@szhsin/react-menu";
import {useTranslation} from "react-i18next";
import {AccessType} from "../../../models/AccessType";
import {ListItemContextMenu, openInNewTab, useListContextMenu} from "../../Widgets/ListItemContextMenu/ListItemContextMenu";

function MyPatients() {
    const {t} = useTranslation();
    const history = useNavigate();
    const userInfo = useAppSelector(selectUserInfo);
    const {menuProps, anchorPoint, targetId, onContextMenu, close} = useListContextMenu();
    const patientPath = (id: string) => `${MY_PATIENTS_ROUTE}/${id}`;
    const patientClickHandler = (id: string) => {
        history(patientPath(id));
    };
    const openClickHandler = () => {
        if (targetId) {
            patientClickHandler(targetId);
        }
    };
    const openInNewTabClickHandler = () => {
        if (targetId) {
            openInNewTab(patientPath(targetId));
        }
    };
    const shareClickHandler = () => {
        if (targetId) {
            history(`${MY_PATIENTS_ROUTE}/${targetId}/share`);
        }
    };
    return (
        <div>
            <Breadcrumbs/>
            <PatientsList tag="list_my_patients" pageSize={DATA_LIST_PAGE_SIZE} userId={userInfo?.id ?? null} accessType={AccessType.Owner}
                          patientClickHandler={patientClickHandler} contextMenuHandler={onContextMenu}/>
            <ListItemContextMenu menuProps={menuProps} anchorPoint={anchorPoint}
                                 onClose={close} onOpen={openClickHandler} onOpenInNewTab={openInNewTabClickHandler}>
                <MenuItem onClick={shareClickHandler}>{t("access_control")}</MenuItem>
            </ListItemContextMenu>
        </div>
    );
}

export default MyPatients;
